import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import useGlobalPersistentState from '@fdc/hooks/useGlobalPersistentState';

import { sessionStorageService } from '@contentservice/shared/services/storage/session-storage.service';

const NEW_USER_SIGNUP_ADDRESS_DIALOG = 'newUserSignUpAddressDialog';

interface NewUserAddressDialogActionState {
  openOnAddToCart?: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
}

const defaultNewUserAddressDialogActionState: NewUserAddressDialogActionState =
  {
    openOnAddToCart: false,
    onClose: undefined,
    onConfirm: undefined,
  };

const showNewUserAddressDialogOnPageLoadVar = makeVar<boolean>(true);

const newUserAddressDialogActionVar = makeVar<NewUserAddressDialogActionState>(
  defaultNewUserAddressDialogActionState
);

export const handleOpenNewAddressDialog = (
  openOnAddToCart = true,
  onClose?: () => void,
  onConfirm?: () => void
) => {
  newUserAddressDialogActionVar({
    openOnAddToCart: openOnAddToCart,
    onClose,
    onConfirm,
  });
};

export const closeNewUserAddressDialog = (onClose: () => void) => {
  newUserAddressDialogActionVar({
    onClose,
  });
};

export const useNewUserAddressDialogAction = () => {
  return useReactiveVar(newUserAddressDialogActionVar);
};

export const useNewUserAddressDialog = () => {
  const [newUserAddressDialogState, setNewUserAddressDialogState] =
    useGlobalPersistentState<boolean>(
      NEW_USER_SIGNUP_ADDRESS_DIALOG,
      showNewUserAddressDialogOnPageLoadVar
    );

  const setOpenDialogOnPageLoad = (value: boolean) => {
    setNewUserAddressDialogState(value);
  };

  return {
    newUserAddressDialogState,
    setOpenDialogOnPageLoad,
  };
};

export const clearNewUserAddressDialogState = () => {
  sessionStorageService.remove(NEW_USER_SIGNUP_ADDRESS_DIALOG);
};
